import { useSelector } from "react-redux";
import shallowEqual from "react-redux/es/utils/shallowEqual";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import * as PhonenumberPrefixesSelectors from "@/redux/modules/api/data/phonenumberPrefixes/phonenumberPrefixes.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { PhoneField } from "../../FormFields/PhoneField/phoneField.container";
import { TextField } from "../../FormFields/TextField/Textfield.component";
import { CustomerTypeFormBlock } from "./components/customerType.component";
import { CustomerFormBlockFormValues } from "./customerFormBlock.schema";

const CustomerFormBlockComponent = <
    _ extends CustomerFormBlockFormValues
>() => {
    const { t } = useGranite();

    const phonenumberPrefixes = useSelector(
        PhonenumberPrefixesSelectors.getPhonenumberPrefixes,
        shallowEqual
    );

    return (
        <>
            <CustomerTypeFormBlock />
            <Row>
                <Col
                    xs={12}
                    md={6}
                >
                    <TextField<CustomerFormBlockFormValues>
                        test="customerDetailsFormBlock-input-firstName"
                        name="firstName"
                        label={t("general.form.firstName.label")}
                        required
                        autoComplete={"given-name"}
                        placeholder={t("general.form.firstName.placeholder")}
                    />
                </Col>
                <Col
                    xs={12}
                    md={6}
                >
                    <TextField<CustomerFormBlockFormValues>
                        test="customerDetailsFormBlock-input-lastName"
                        name="lastName"
                        label={t("general.form.lastName.label")}
                        required
                        autoComplete={"family-name"}
                        placeholder={t("general.form.lastName.placeholder")}
                    />
                </Col>
            </Row>
            <Row>
                <Col md={6}>
                    <PhoneField<CustomerFormBlockFormValues>
                        test="customerDetailsFormBlock-input-phone"
                        autoComplete={"tel-national"}
                        label={t("general.form.phoneNumber.label")}
                        placeholder={t("general.form.phoneNumber.placeholder")}
                        phonenumberPrefixes={phonenumberPrefixes}
                        required
                    />
                </Col>
            </Row>
        </>
    );
};

export { CustomerFormBlockComponent };
